module.exports = __webpack_public_path__ + "static/media/logocovinoc.630b9e3f.svg";